import {
  object,
  string,
  array,
  number,
  boolean,
  SchemaOf,
  StringSchema,
} from 'yup';

import {
  AllowedHostPath,
  IdRange,
  KubernetesSecurityFormValues,
  SeLinuxOption,
} from './types';

const allowedHostPathSchema: SchemaOf<AllowedHostPath> = object({
  pathPrefix: string().required(),
  readonly: boolean().required(),
});

const idRangeSchema: SchemaOf<IdRange> = object({
  min: number().required(),
  max: number().required(),
});

const seLinuxOptionSchema: SchemaOf<SeLinuxOption> = object({
  level: string().required(),
  role: string().required(),
  type: string().required(),
  user: string().required(),
});

export function createKubernetesSecurityValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<KubernetesSecurityFormValues> {
  return object({
    // PolicyConfigFormValues
    name: nameValidation,
    environmentGroupIds: array(number().required()),

    // Security section
    restrictDefaultNamespace: boolean().required(),
    restrictSecrets: boolean().required(),
    enableNodeShell: boolean().required(),

    // Pod security constraints
    enablePodSecurityConstraints: boolean().required(),
    restrictPrivilegedContainers: boolean().required(),
    restrictHostNamespace: boolean().required(),
    restrictHostNetworkingPorts: boolean().required(),
    hostNetwork: boolean().required(),
    hostPortMin: number().required(),
    hostPortMax: number().required(),
    restrictVolumeTypes: boolean().required(),
    allowedVolumeTypes: array(string().required()),
    restrictHostFilesystemPaths: boolean().required(),
    allowedHostPaths: array(allowedHostPathSchema),
    restrictDrivers: boolean().required(),
    allowedFlexVolumeDrivers: array(string().required()),
    requireReadOnlyRootFilesystem: boolean().required(),
    restrictUserAndGroupIds: boolean().required(),
    runAsUserType: string().required(),
    runAsUserRanges: array(idRangeSchema),
    runAsGroupType: string().required(),
    runAsGroupRanges: array(idRangeSchema),
    supplementalGroupsType: string().required(),
    supplementalGroupsRanges: array(idRangeSchema),
    fsGroupType: string().required(),
    fsGroupRanges: array(idRangeSchema),
    restrictEscalationToRootPrivileges: boolean().required(),
    restrictLinuxCapabilities: boolean().required(),
    allowedCapabilities: array(string().required()),
    requiredDropCapabilities: array(string().required()),
    defaultAddCapabilities: array(string().required()),
    restrictSeLinuxSecurityContext: boolean().required(),
    seLinuxOptions: array(seLinuxOptionSchema),
    restrictProcMountTypes: boolean().required(),
    procMountType: string().required(),
    restrictAppArmorProfiles: boolean().required(),
    allowedAppArmorProfiles: array(string().required()),
    restrictSeccompProfiles: boolean().required(),
    allowedSeccompProfiles: array(string().required()),
    restrictSysctlProfiles: boolean().required(),
    forbiddenSysctls: array(string().required()),
  });
}
